import { UseQueryResult } from "@tanstack/react-query";
import { mapQuery } from "../../utilities/query/mapQuery";
import { useLogbookSettings } from "./useLogbookSettings";

/**
 * Returns the configured days to edit for the current database.
 */
export function useDaysToEdit(): UseQueryResult<number> {
  return mapQuery(useLogbookSettings(), settings => settings.numberOfDays);
}
